import React from 'react';
import { Grid } from '@mui/material';
import { v1 } from 'uuid';
import { StyledGridItem, StyledGridList } from './styles';
var StatusBar = function (_a) {
    var _b = _a.activeIndex, activeIndex = _b === void 0 ? 0 : _b, items = _a.items;
    return (React.createElement(StyledGridList, { container: true, component: "ul", id: "StatusBar", length: items === null || items === void 0 ? void 0 : items.length }, (items === null || items === void 0 ? void 0 : items.length)
        ? items.map(function (item, index) { return (React.createElement(Grid, { key: v1(), item: true, className: index <= activeIndex ? 'active' : '', component: StyledGridItem }, item.label)); })
        : null));
};
export default StatusBar;
//# sourceMappingURL=StatusBar.js.map